var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error text-center"},[_c('i',{staticClass:"fa fa-exclamation-triangle icon"}),_vm._v(" "),_c('h1',{staticClass:"h3 font-weight-bold"},[_vm._v("Not Found")]),_vm._v(" "),_c('p',[_vm._v("Sorry, the content you were looking for could not be found.")])])
}]

export { render, staticRenderFns }